function rightMenuDdm() {
    $('.right-menu_block').dropDownMenu({
        disabled:    false,
        classBtn:    'right-menu_button--opener',
        independent: false
    });
}
